"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import type { SupportedChain, TokenMetadata, TokenRange } from "../types";
import { formatCanonical } from "../utils";
import { VirtualizedTokenList } from "@/components/token-list/VirtualizedTokenList";
interface NftTokenListProps {
  readonly contractAddress?: `0x${string}` | undefined;
  readonly chain: SupportedChain;
  readonly ranges: TokenRange[];
  readonly overscan?: number | undefined;
  readonly renderTokenExtra?: ((tokenId: bigint, metadata?: TokenMetadata) => ReactNode) | undefined | undefined;
  readonly onRemove: (tokenId: bigint) => void;
}
export function NftTokenList(t0) {
  const $ = _c(13);
  const {
    contractAddress,
    chain,
    ranges,
    overscan,
    renderTokenExtra,
    onRemove
  } = t0;
  let t1;
  if ($[0] !== onRemove) {
    t1 = onRemove ? {
      label: "Remove",
      onClick: onRemove,
      getAriaLabel: _temp
    } : undefined;
    $[0] = onRemove;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ranges) {
    t2 = formatCanonical(ranges);
    $[2] = ranges;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-text-sm tw-text-iron-300">No tokens selected.</div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== chain || $[6] !== contractAddress || $[7] !== overscan || $[8] !== ranges || $[9] !== renderTokenExtra || $[10] !== t1 || $[11] !== t2) {
    t4 = <VirtualizedTokenList contractAddress={contractAddress} chain={chain} ranges={ranges} overscan={overscan} scrollKey="nft-picker-token-list" renderTokenExtra={renderTokenExtra} action={t1} footerContent={t2} emptyState={t3} />;
    $[5] = chain;
    $[6] = contractAddress;
    $[7] = overscan;
    $[8] = ranges;
    $[9] = renderTokenExtra;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp(tokenLabel) {
  return `Remove token ${tokenLabel}`;
}